import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngxs/store';
import { BusinessDispatch, BusinessState } from '@state/business';
import { BusinessFeeSettingsFirestorePaths } from '../../business-finances-general/business-finances-general.types';
import { TestHooks } from './idv-treefort-verification-general.hooks';

@Component({
	selector: 'app-idv-treefort-verification-general',
	templateUrl: './idv-treefort-verification-general.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class IdvTreefortVerificationGeneralComponent {
	testHooks = TestHooks;
	public defaultIdvSettingsSignal = toSignal(
		inject(Store).select(BusinessState.getDefaultIdvFeeSettings),
	);

	public treefortSettingsSignal = toSignal(
		inject(Store).select(BusinessState.getTreefortVerificationSettings),
	);

	constructor(private businessDispatch: BusinessDispatch) {}

	setHst(isHst: boolean): void {
		const firestoreIdvSettingsPath = BusinessFeeSettingsFirestorePaths.IDV;

		this.businessDispatch.OverwriteBusinessFields(
			`defaultSettings.${firestoreIdvSettingsPath}.hst`,
			isHst,
		);
	}

	setSecondaryIdRequired(secondaryIdRequired: boolean): void {
		this.businessDispatch.OverwriteBusinessFields(
			`defaultSettings.idv.treefortVerificationSettings.secondaryIdRequired`,
			secondaryIdRequired,
		);
	}

	setReqFinancialInstLogin(financialInstLoginRequired: boolean): void {
		this.businessDispatch.OverwriteBusinessFields(
			`defaultSettings.idv.treefortVerificationSettings.financialInstitutionLoginRequired`,
			financialInstLoginRequired,
		);
	}

	setReqAdvAmlScreening(advAmlScreeningRequired: boolean): void {
		this.businessDispatch.OverwriteBusinessFields(
			`defaultSettings.idv.treefortVerificationSettings.advancedAMLScreeningRequired`,
			advAmlScreeningRequired,
		);
	}
}
